import coreUtils from 'eop-ui-core/utils'
import buildApiUtils from 'eop-ui-core/utils/apiUtils'
import api from '@/api'
import store from '@/store'
import { CLIENT_KEY } from '@/constants'
import SearchOption from 'eop-ui-core/models/SearchOption'

const utils = {
  ...coreUtils,
  ...buildApiUtils({ api, buildTokenString }),
  openSubsystemUrl: (
    webApplicationName: 'BizWeb' | 'FacilityWeb',
    path: string,
    settings: OpenSubsystemUrlSettings = { newWindow: true },
  ) => {
    let entryUri
    switch (webApplicationName) {
      case 'BizWeb':
        entryUri = '/b/'
        break
      case 'FacilityWeb':
        entryUri = '/f/'
        break
      default:
        return
    }
    entryUri += path
    entryUri += new SearchOption({
      condition: {
        _ts: new Date().getTime(),
        ...(settings.query || {}),
      },
    }).toQueryString()
    if (settings.newWindow) {
      window.open(entryUri, '_blank')
    } else {
      window.location.href = entryUri
    }
  },
}
export default utils

function buildTokenString() {
  return window.btoa(
    JSON.stringify({
      tenantScope: 'Platform',
      tenantId: 'eop',
      accessToken: store.getters['accounts/getUserAccount']?.accessToken,
      clientKey: CLIENT_KEY,
    }),
  )
}
type OpenSubsystemUrlSettings = {
  newWindow?: boolean
  query?: Record<string, string>
}
